import { render, staticRenderFns } from "./McaCurrentSpectrum.vue?vue&type=template&id=2cae5b6e&scoped=true"
import script from "./McaCurrentSpectrum.vue?vue&type=script&lang=ts"
export * from "./McaCurrentSpectrum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae5b6e",
  null
  
)

export default component.exports